import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import NebulyxLogo from '../assets/images/Nebulyx-logo-white.svg';
import {Link} from "react-router-dom";

/**
 * Footer component with links and contact information
 */
const Footer = ()=> {
    return (
        <footer className="bg-dark text-white py-5">
            <Container>
                <Row>
                    {/* Company info and logo */}
                    <Col md={4} className="mb-4">
                        <img
                            src={NebulyxLogo}
                            alt="Nebulyx-AI Your Digital Transformation Acclerator"
                            height="40"
                            className="d-inline-block align-top mb-3"
                        />
                        <p className="small">Nebulyx.ai, Nebulyx AI Studio, Nebulyx Cognition and AgentDOG are owned by NEBULYX AI Ltd. Copyright © 2026 NEBULYX AI Ltd, Beacon House, South Road, Weybridge, Surrey, KT13 8DR, United Kingdom.</p>

                        {/* Social media links */}
                        <div className="social-links">
                            <a href="https://www.linkedin.com/company/nebulyx-ai/" className="text-white me-3" target="_blank" rel="noopener noreferrer">
                                <i className="bi bi-linkedin"></i>
                            </a>
                            <a href="https://www.youtube.com/@DataProductWorkshop-com" className="text-white" target="_blank" rel="noopener noreferrer">
                                <i className="bi bi-youtube"></i>
                            </a>
                        </div>
                    </Col>


                    {/* Contact information */}
                    <Col md={4} className="mb-4" id="contact">
                        <h5 className="mb-3">Contact</h5>
                        <p>Beacon House, South Road<br />Weybridge, Surrey<br />KT13 8DR, United Kingdom</p>
                        <p>Email: info@nebulyx.ai</p>

                        {/* CTA button */}
                        <Button variant="outline-light" href="mailto:info@nebulyx.ai">
                            Get In Touch
                        </Button>
                    </Col>
                    <Col md={4} className="mb-4">
                        <h5 className="mb-3">Legal and Regulatory Compliance</h5>
                        <Link to={"/privacy-policy"}>Privacy policy</Link>
                    </Col>
                </Row>

                {/* Copyright line */}
                <hr className="my-4" />

                <Row>
                    <Col className="text-center">
                        <p className="small mb-0">All rights reserved. No part of this website or its content may be reproduced without the copyright owner's permission.</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;